export default "__VITE_ASSET__Cw1lPHb___"